export default __webpack_public_path__ + "static/media/sat-7.ca6e18b0.png";